import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { FormValues, bookingForValues } from '../schema'

export const useBookingForWatcher = () => {
	const { setValue, control } = useFormContext<FormValues>()
	const bookingFor = useWatch({ control, name: 'bookingFor' })
	const bookerName = useWatch({ control, name: 'name' })
	const bookerSurname = useWatch({ control, name: 'surname' })

	useEffect(() => {
		if (bookingFor === bookingForValues.ME) {
			setValue('room.0.0.name', bookerName)
			setValue('room.0.0.surname', bookerSurname)
		}
	}, [bookerName, bookerSurname, bookingFor, setValue])

	useEffect(() => {
		if (bookingFor === bookingForValues.OTHER) {
			setValue('room.0.0.name', '')
			setValue('room.0.0.surname', '')
		}
	}, [bookingFor, setValue])
}
